import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import AtlasV2PricesSummarySplineChart from 'src/components/AtlasV2Components/AtlasV2PricesPageComponents/AtlasV2PricesSummarySplineChart';
import AtlasV2PricesPriceIndexSplineChart from 'src/components/AtlasV2Components/AtlasV2PricesPageComponents/AtlasV2PricesPriceIndexSplineChart';
import AtlasV2PricesTopEntityChart from 'src/components/AtlasV2Components/AtlasV2PricesPageComponents/AtlasV2PricesTopEntityChart';
import AtlasV2PricesProductGrid from 'src/components/AtlasV2Components/AtlasV2PricesPageComponents/AtlasV2PricesProductGrid';
import { useCategoryEntity, useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Price Summary Page layout - Tab name: prices subtab name: retailPrice
 */
export const AtlasV2PriceSummaryPageLayout = () => {
  const { isAllCategoriesEntity } = useCategoryEntity();
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {/* Retail Price  */}
        <AtlasV2PricesSummarySplineChart />
        {/* Price Index */}
        {!isAllCategoriesEntity && <AtlasV2PricesPriceIndexSplineChart />}
        {/* Retail Price TopEntity Chart */}
        {!isProductEntity && <AtlasV2PricesTopEntityChart />}
        {/* Retail Price Product Grid */}
        <AtlasV2PricesProductGrid />
      </Flex>
    </BasePageContainer>
  );
};
